// import Cookies from 'js-cookie';
import * as CONSTANTS from 'config/constants';
import {
  Authentication,
  Dashboard,
  Forbidden,
  Jobs,
  JustOnce,
  NannyDetail,
  NannyList,
  ParentDetail,
  ParentList,
  PayoutsDetail,
  Recurring,
  RequestsDetail,
  SitterDetail,
  SitterList,
  Superadmin,
  TopUpsFinance,
  Transaction,
  UserFlags,
  Users,
} from 'modules';
import CheckOTP from 'modules/Authentication/CheckOTP';
import {
  ActivityLogAC,
  JobDetail,
  PackagesAC,
  ParentOverviews,
  SitterDetailAC,
  SitterListAC,
  Subscription,
  SubscriptionDetail,
  TopUpsConcierge,
} from 'modules/Concierge';
import PublicHolidayPage from 'modules/Concierge/PublicHoliday';
import CashFee from 'modules/Finance/Cash Fee';
import Payouts from 'modules/Finance/Payouts';
import FinanceSettings from 'modules/FinanceSettings';
import { ListNannyBooking, NannyBookingDetail } from 'modules/NannyBookings';
import Promotions from 'modules/Promotions';
import Reports from 'modules/Reports';
import Reviews from 'modules/Reviews';
import Settings from 'modules/Settings';
import { Route, Routes } from 'react-router-dom';
import { useAppSelector } from 'store/hook';
import PrivateRoute from './PrivateRoute';

const AppRoute = () => {
  const { isLoggedIn } = useAppSelector((state) => state.authenticationReducer);
  const token = localStorage.getItem(CONSTANTS.ACCESS_TOKEN);
  // const tokenPayload = token ? parseJwt(token) : null;
  // console.log('tokenPayload', tokenPayload);

  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PrivateRoute
            redirectPath="/"
            isLoggedIn={!Boolean(token) || !isLoggedIn}
          >
            <Authentication />
          </PrivateRoute>
        }
      />
      <Route
        path="/check-otp"
        element={
          <PrivateRoute
            redirectPath="/"
            isLoggedIn={!Boolean(token) || !isLoggedIn}
          >
            <CheckOTP />
          </PrivateRoute>
        }
      />
      <Route
        path="/"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/jobs"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <Jobs />
          </PrivateRoute>
        }
      />

      <Route
        path="/jobs/:id"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <JobDetail />
          </PrivateRoute>
        }
      />

      <Route
        path="/accounts/parents"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <ParentList />
          </PrivateRoute>
        }
      />
      <Route
        path="/accounts/parents/:parent_id"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <ParentDetail />
          </PrivateRoute>
        }
      />
      <Route
        path="/accounts/sitters"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <SitterList />
          </PrivateRoute>
        }
      />
      <Route
        path="/accounts/sitters/:sitter_id"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <SitterDetail />
          </PrivateRoute>
        }
      />
      <Route
        path="/accounts/nanny"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <NannyList />
          </PrivateRoute>
        }
      />
      <Route
        path="/accounts/nanny/:nannyId"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <NannyDetail />
          </PrivateRoute>
        }
      />
      <Route
        path="/accounts/admins"
        element={
          <PrivateRoute
            isLoggedIn={Boolean(token) || isLoggedIn}
            roles={['superadmin']}
          >
            <Superadmin />
          </PrivateRoute>
        }
      />
      <Route
        path="/accounts/users"
        element={
          <PrivateRoute
            isLoggedIn={Boolean(token) || isLoggedIn}
            roles={['superadmin']}
          >
            <Users />
          </PrivateRoute>
        }
      />

      <Route
        path="/finance/top-ups"
        element={
          <PrivateRoute
            roles={['superadmin']}
            isLoggedIn={Boolean(token) || isLoggedIn}
          >
            <TopUpsFinance />
          </PrivateRoute>
        }
      />
      <Route
        path="/finance/payouts"
        element={
          <PrivateRoute
            roles={['superadmin']}
            isLoggedIn={Boolean(token) || isLoggedIn}
          >
            <Payouts />
          </PrivateRoute>
        }
      />
      <Route
        path="/finance/cash-fee"
        element={
          <PrivateRoute
            roles={['superadmin']}
            isLoggedIn={Boolean(token) || isLoggedIn}
          >
            <CashFee />
          </PrivateRoute>
        }
      />
      <Route
        path="/finance/payouts/:id"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <PayoutsDetail />
          </PrivateRoute>
        }
      />
      <Route
        path="/finance/cash-fee"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <CashFee />
          </PrivateRoute>
        }
      />
      <Route
        path="/finance/transactions"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <Transaction isAA={true} />
          </PrivateRoute>
        }
      />

      <Route
        path="/requests/just-once"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <JustOnce />
          </PrivateRoute>
        }
      />
      <Route
        path="/requests/recurring"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <Recurring />
          </PrivateRoute>
        }
      />

      <Route
        path="/requests/recurring/:id"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <RequestsDetail />
          </PrivateRoute>
        }
      />

      <Route
        path="/requests/just-once/:id"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <RequestsDetail />
          </PrivateRoute>
        }
      />

      <Route
        path="/settings"
        element={
          <PrivateRoute
            isLoggedIn={Boolean(token) || isLoggedIn}
            roles={['superadmin']}
          >
            <Settings />
          </PrivateRoute>
        }
      />
      <Route
        path="/finance-settings"
        element={
          <PrivateRoute
            isLoggedIn={Boolean(token) || isLoggedIn}
            roles={['superadmin']}
          >
            <FinanceSettings />
          </PrivateRoute>
        }
      />
      <Route
        path="/reports"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <Reports />
          </PrivateRoute>
        }
      />
      <Route
        path="/nanny-bookings"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <ListNannyBooking />
          </PrivateRoute>
        }
      />
      <Route
        path="/nanny-bookings/:bookingId"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <NannyBookingDetail />
          </PrivateRoute>
        }
      />
      <Route
        path="/promotions"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <Promotions />
          </PrivateRoute>
        }
      />
      <Route
        path="/reviews"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <Reviews />
          </PrivateRoute>
        }
      />

      <Route
        path="/user-flags"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <UserFlags />
          </PrivateRoute>
        }
      />

      <Route
        path="/concierge/sitters-ac"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <SitterListAC />
          </PrivateRoute>
        }
      />

      <Route
        path="/concierge/sitters-ac/:sitter_id"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <SitterDetailAC />
          </PrivateRoute>
        }
      />

      <Route
        path="/concierge/parent-overviews"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <ParentOverviews />
          </PrivateRoute>
        }
      />

      <Route
        path="/concierge/package"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <PackagesAC />
          </PrivateRoute>
        }
      />

      <Route
        path="/concierge/public-holiday"
        element={
          <PrivateRoute
            roles={['superadmin', 'staff']}
            isLoggedIn={Boolean(token) || isLoggedIn}
          >
            <PublicHolidayPage />
          </PrivateRoute>
        }
      />

      <Route
        path="/concierge/subscription"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <Subscription />
          </PrivateRoute>
        }
      />

      <Route
        path="/concierge/transactions"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <Transaction isAA={false} />
          </PrivateRoute>
        }
      />

      <Route
        path="/concierge/top-ups"
        element={
          <PrivateRoute
            roles={['superadmin']}
            isLoggedIn={Boolean(token) || isLoggedIn}
          >
            <TopUpsConcierge />
          </PrivateRoute>
        }
      />

      <Route
        path="/concierge/activity-logs"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <ActivityLogAC />
          </PrivateRoute>
        }
      />

      <Route
        path="/concierge/subscription/:id"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <SubscriptionDetail />
          </PrivateRoute>
        }
      />

      <Route
        path="/concierge/ac-payouts"
        element={
          <PrivateRoute
            roles={['superadmin']}
            isLoggedIn={Boolean(token) || isLoggedIn}
          >
            <Payouts isAC={true} />
          </PrivateRoute>
        }
      />

      <Route
        path="/forbidden"
        element={
          <PrivateRoute isLoggedIn={Boolean(token) || isLoggedIn}>
            <Forbidden />
          </PrivateRoute>
        }
      />

      <Route path="*" element={<p>There's nothing here: 404!</p>} />
    </Routes>
  );
};

export default AppRoute;
